import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5","key":"svg-0"}],["path",{"d":"M20.87 10.48a9 9 0 1 0 -7.876 10.465","key":"svg-1"}],["path",{"d":"M9 10h.01","key":"svg-2"}],["path",{"d":"M15 10h.01","key":"svg-3"}],["path",{"d":"M9.5 15c.658 .64 1.56 1 2.5 1c.357 0 .709 -.052 1.043 -.151","key":"svg-4"}]]

const IconMoodBitcoin = createReactComponent('outline', 'mood-bitcoin', 'MoodBitcoin', __iconNode);

export default IconMoodBitcoin;